<template>
    <div class="environment_box animate__animated animate__fadeIn">
        <div class="environment">
            <!-- 环境监测详情 -->
            <div class="content_list">
                <div class="item_title">
                    <div class="bar">设备类型：{{ fnTyptText(currentEnvironment.type) }}</div>
                    <div class="bar">设备编号：{{ currentEnvironment.number ? currentEnvironment.number : '' }}</div>
                    <div class="bar">
                        运行状态：{{ currentEnvironment.eqptStatus ? fnEnvrionmentStatusToText(currentEnvironment.eqptStatus).msg : '' }}
                    </div>
                    <div class="bar">监测时间：{{ recordAt }}</div>
                    <div class="operation">
                        <div class="search-btn" @click="fnOpenEnvironmentRealTimeRecord"><span>实时记录</span></div>
                        <div class="search-btn orange" @click="fnRefresh"><span>刷新</span></div>
                    </div>
                </div>
                <div class="item_box">
                    <div class="box" v-show="statusIndex == 0">
                        <Data :currentEnvironment="currentEnvironment" />
                    </div>
                    <div class="box" v-show="statusIndex == 1">
                        <alarm :currentEnvironment="currentEnvironment" />
                    </div>
                    <div class="box" v-show="statusIndex == 2">
                        <real-time-record :currentEnvironment="currentEnvironment"></real-time-record>
                    </div>
                </div>
            </div>
            <div class="data_list">
                <div class="title">环境监测({{ EnvironmentData.length }}台)</div>
                <div class="list_title">
                    <div class="title_item">设备编号</div>
                    <div class="title_item" style=" width: 66px;">类型</div>
                    <div class="title_item" style=" width: 66px;">状态</div>
                    <div class="title_item">自动除尘</div>
                </div>
                <div class="list_box">
                    <div v-if="EnvironmentData">
                        <div class="box_line" v-for="(item, index) in EnvironmentData" :key="item.id"
                            @click="fnEnvironmentToggle(item, index)"
                            :class="currentEnvironmentIndex == index ? 'active' : ''">
                            <div class="line_item">{{ item.number }}</div>
                            <div class="line_item" style=" width: 66px;">
                                {{ fnTyptText(item.type) }}
                            </div>
                            <div class="line_item" style=" width: 66px;">
                                {{ fnOnlineStatusText(item.heartbeatTime).text }}
                            </div>
                            <div class="line_item">
                                <el-switch v-model="item.is_auto_dust_abatement" :disabled="item.type!=0"
                                    @change="fnDustStatus($event, item.number, item.id)"></el-switch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Data from './components/Data';
    import Alarm from './components/Alarm';
    import realTimeRecord from './components/realTimeRecord';
    import request from '@/utils/request';
    import APP from '@/utils/base';
    import {
        getUserInfo,
        getEqptInfo,
        removeEqptInfo
    } from '@/utils/auth';

    export default {
        components: {
            Data,
            Alarm,
            realTimeRecord
        },
        data() {
            return {
                timer: null,
                projectID: '', // 传递过来的项目信息
                statusIndex: 0,
                recordAt: '',
                currentEnvironmentIndex: 0,
                EnvironmentData: [], // 扬尘列表
                currentEnvironment: {
                    // 当前设备信息
                    number: '',
                    eqptStatus: '',
                    nowTime: '',
                    type: 0
                },
                isIndex: false,
                indexMsg: null,
            };
        },
        created() {
            let _msg = getEqptInfo()
            if (_msg && _msg.pointType == '环境监测设备') {
                this.isIndex = true
                this.indexMsg = _msg.pointNumber
            }
            this.projectID = getUserInfo().id;
            this.fnInit();
            this.timer = setInterval(() => {
                this.fnGetEnvironmentList();
            }, 100000);
        },
        beforeDestroy() {
            removeEqptInfo()
            clearInterval(this.timer);
        },
        methods: {
            fnDustStatus(e, number, id) {
                request({
                        url: '/environmental/edit',
                        method: 'POST',
                        data: {
                            number: number,
                            is_auto_dust_abatement: e ? 1 : 0,
                            id: id
                        }
                    })
                    .then(res => {
                        this.$message.success(res.data);
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 查看环境监测记录
            fnOpenEnvironmentRealTimeRecord() {
                this.statusIndex = 2;
            },
            // 查看环境监测预报警次数
            fnOpenEnvironmentAlarm() {
                this.statusIndex = 1;
            },
            // 查看实时数据
            fnOpenHome() {
                this.statusIndex = 0;
            },
            // 记录切换
            fnStatusToggle(_el) {
                let _index = _el.target.dataset.index;
                if (_index != this.statusIndex) {
                    this.statusIndex = _index;
                }
            },
            // 初始化
            fnInit() {
                this.fnGetEnvironmentList();
            },
            // 获取扬尘列表公共方法
            fnGetEnvironmentList() {
                request({
                        notLoading: true,
                        url: '/environmental/get',
                        method: 'GET',
                        params: {
                            project_id: this.projectID
                        }
                    })
                    .then(res => {
                        let _data = res.data.query;
                        if (_data.length > 0) {
                            for (var i in _data) {
                                if (_data[i].is_auto_dust_abatement === 1) {
                                    _data[i].is_auto_dust_abatement = true;
                                } else {
                                    _data[i].is_auto_dust_abatement = false;
                                }
                            }
                            this.EnvironmentData = _data;
                            if (this.currentEnvironmentIndex) {
                                for (let i in _data) {
                                    if (_data[i].number == this.currentEnvironmentIndex) {
                                        this.currentEnvironmentIndex = i
                                        this.currentEnvironment.number = _data[i].number
                                        this.currentEnvironment.eqptStatus = _data[i].eqptStatus
                                        this.currentEnvironment.type = _data[i].type
                                        this.currentEnvironment.nowTime = '' + new Date().getTime()
                                    }
                                }
                            } else {
                                this.currentEnvironment.number = _data[0] ? _data[0].number : '';
                                this.currentEnvironment.eqptStatus = _data[0] ? _data[0].eqptStatus : '';
                                this.currentEnvironment.type = _data[0] ? _data[0].type : '';
                                this.currentEnvironment.nowTime = '' + new Date().getTime()
                            }
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 扬尘运行状态
            fnEnvrionmentStatusToText(_status) {
                return APP.fnCraneStatusToText(_status, 'environment');
            },
            // 获取选中塔机信息
            fnEnvironmentToggle(_item, _index) {
                this.currentEnvironmentIndex = _index;
                request({
                        url: '/environmental/get',
                        method: 'GET',
                        params: {
                            number: _item.number
                        }
                    })
                    .then(res => {
                        this.currentEnvironment.number = res.data.query[0].number;
                        this.currentEnvironment.eqptStatus = res.data.query[0].eqptStatus;
                        this.currentEnvironment.type = res.data.query[0].type;
                        this.currentEnvironment.nowTime = '' + new Date().getTime()
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            fnGetTimes(time) {
                this.recordAt = time ? time : '无记录';
            },
            fnTyptText(_type) {
                switch (_type) {
                    default:
                    case 0:
                        return '扬尘';
                    case 1:
                        return '单独扬尘';
                    case 2:
                        return '单独噪音';
                    case 3:
                        return '气象站';
                    case 4:
                        return '污水';
                    case 5:
                        return '废气';
                }
            },
            // 塔机在线状态
            fnOnlineStatusText(_heartbeatTime) {
                return APP.fnOnlineStatusText(_heartbeatTime);
            },
            // 刷新
            fnRefresh() {
                if (this.EnvironmentData.length > 0) {
                    this.fnEnvironmentToggle(this.EnvironmentData[this.currentEnvironmentIndex], this
                        .currentEnvironmentIndex);
                }
            }
        }
    };
</script>
<style lang="scss" scoped>
    @import '~@/styles/mixin.scss';

    .environment_box {
        width: 1920px;
        height: 858px;
        position: relative;
        overflow: hidden;

        .environment {
            position: absolute;
            left: 0;
            right: -20px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }

    .content_list {
        position: absolute;
        top: 0;
        left: 0;
        width: 1600px;
        height: 858px;

        .item_title {
            width: 1580px;
            height: 60px;
            margin: 10px;
            position: relative;
            background: url(../../../assets/img/per_list_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(flex-start, center);
        }

        .bar {
            font-size: 20px;
            margin: 0 20px;
        }

        .operation {
            position: absolute;
            right: 10px;
            @include flex-box();
        }

        .item_box {
            width: 1600px;
            height: 778px;
        }
    }

    .data_list {
        position: absolute;
        top: 0;
        left: 1620px;
        width: 300px;
        height: 848px;
        margin-top: 10px;
        background-color: rgba(29, 68, 149, 0.1);

        .title {
            width: 300px;
            height: 60px;
            font-size: 24px;
            background: url(../../../assets/img/per_list_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(center, center);
        }

        .list_title {
            width: 300px;
            height: 48px;
            font-size: 14px;
            padding-left: 8px;
            background: url(../../../assets/img/enter_left_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(flex-start, center);

            .title_item {
                width: 96px;
                margin: 0 2px;
                text-align: center;
            }
        }

        .list_box {
            width: 300px;
            height: 740px;
            padding-left: 5px;

            .box_line {
                width: 300px;
                height: 48px;
                cursor: pointer;
                border-bottom: 1px dashed #1d4495;
                @include flex-box(center, center);

                &:hover {
                    background-color: rgba(49, 88, 128, 0.4);
                }

                &.active {
                    color: #0080FF;
                }

                .line_item {
                    width: 96px;
                    margin: 0 2px;
                    text-align: center;
                    font-size: 14px;
                }
            }
        }
    }

    >>>.el-pager .more:before {
        content: '\E794';
    }

    >>>.el-switch.is-checked .el-switch__core:after {
        content: '';
    }
</style>



// WEBPACK FOOTER //
// src/views/Environmental/environmentDefault/index.vue